// extracted by mini-css-extract-plugin
export default {"main":"VendorShopMain_main__R5+8v","aside":"VendorShopMain_aside__dAkbG","article":"VendorShopMain_article__B-uqY"};